import { render, staticRenderFns } from "./DeductionRecord.vue?vue&type=template&id=d1c0a828&scoped=true&"
import script from "./DeductionRecord.vue?vue&type=script&lang=js&"
export * from "./DeductionRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeductionRecord.vue?vue&type=style&index=0&id=d1c0a828&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c0a828",
  null
  
)

export default component.exports